export default __webpack_public_path__ + "static/media/14_1_1.b5bfc2af.png";